import { NgModule } from '@angular/core';

import { AdminFilterPipe } from './admin-filter.pipe';
import { BoldTextPipe } from './bold-text.pipe';
import { CurrencyPipe } from './currency.pipe';
import { DateFormatTimezonePipe } from './date-format-timezone.pipe';
import { DaysLeftPipe } from './days-left.pipe';
import { DurationPipe } from './duration.pipe';
import { EncodeHTMLPipe } from './encode-html.pipe';
import { FileSizePipe } from './file-size.pipe';
import { RemoveHTMLTagsPipe } from './remove-html-tags.pipe';
import { RoundNumberPipe } from './round-number.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SimpleFormatPipe } from './simple-format.pipe';
import { SourceNamePipe } from './source-name.pipe';
import { TruncatePipe } from './truncate.pipe';
import { TypeofPipe } from './typeof.pipe';

const PIPES = [
  RoundNumberPipe,
  CurrencyPipe,
  DaysLeftPipe,
  DurationPipe,
  SafeHtmlPipe,
  AdminFilterPipe,
  EncodeHTMLPipe,
  FileSizePipe,
  RemoveHTMLTagsPipe,
  SimpleFormatPipe,
  SourceNamePipe,
  DateFormatTimezonePipe,
  BoldTextPipe,
  TruncatePipe,
  TypeofPipe,
];

@NgModule({
  imports: [...PIPES],
  exports: PIPES,
})
export class PipesModule {}

export {
  RoundNumberPipe,
  CurrencyPipe,
  DaysLeftPipe,
  DurationPipe,
  SafeHtmlPipe,
  AdminFilterPipe,
  EncodeHTMLPipe,
  FileSizePipe,
  RemoveHTMLTagsPipe,
  SimpleFormatPipe,
  SourceNamePipe,
  DateFormatTimezonePipe,
  TruncatePipe,
  TypeofPipe,
};
